export default __webpack_public_path__ + "static/melttogether-ca07fd8f85edccbc48781ca8f8f7a359.png";